import '../../modules/mode-components';

import * as angular from 'angular';
import { differenceInSeconds, parseISO } from 'date-fns';

import template from './status-loader.html';

class StatusLoaderController {
  static $inject = ['$timeout', '$element'];

  private createdAt: Date | string;
  private simple?: string;
  private pulseOnly?: string;
  private targetPercent?: number;
  private targetSeconds?: number;

  private progress: any;
  private percent: number;
  private activeTimeout: angular.IPromise<void>;
  private currentValue: Date | string | null;

  constructor(
    private $timeout: angular.ITimeoutService,
    private $element
  ) {
    this.progress = this.$element.find('.progress-bar');
  }

  $onChanges(changed) {
    if (changed.createdAt) {
      this.updateCreatedAt();
    }
  }

  $onDestroy() {
    this.cancelTimer();
  }

  updateCreatedAt() {
    if (typeof this.createdAt === 'undefined' || this.createdAt === null || this.createdAt === '') {
      this.cancelTimer();
      if (this.currentValue) {
        this.currentValue = null;
      }
      return;
    }

    this.currentValue = this.createdAt;

    this.cancelTimer();
    if (this.currentValue) {
      const safeCurrentValue = typeof this.createdAt === 'string' ? parseISO(this.createdAt) : this.createdAt;
      this.updateTime(safeCurrentValue);
    }
  }

  updateTime(currentValue: Date): void {
    const now = new Date();
    const seconds = differenceInSeconds(now, currentValue);
    const tPercent = this.targetPercent ? this.targetPercent / 100 : 0.75;
    const tSeconds = this.targetSeconds || 30;
    this.percent = Math.min(96, ((Math.log10(seconds) * tPercent) / Math.log10(tSeconds)) * 100);

    this.progress.css('width', this.percent + '%');

    this.activeTimeout = this.$timeout(() => {
      this.updateTime(currentValue);
    }, 1000);
  }

  cancelTimer() {
    if (this.activeTimeout) {
      this.$timeout.cancel(this.activeTimeout);
    }
  }
}

const StatusLoaderComponent: angular.IComponentOptions = {
  bindings: {
    createdAt: '<',
    simple: '@?',
    pulseOnly: '@?',
    targetPercent: '@?',
    targetSeconds: '@?',
  },
  template: template,
  controller: StatusLoaderController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('statusLoader', StatusLoaderComponent);
